<script lang="ts" setup>
import { watch } from "vue";
import { useMessageStore } from "@/stores/message";

const props = defineProps<{
  modelValue: boolean;
  text: string;
  persistent?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  confirm: [];
}>();

const messageStore = useMessageStore();

watch(
  () => props.modelValue,
  (isOpen) => {
    if (isOpen) messageStore.clearMessage();
  }
);

const handleConfirm = () => {
  emit("confirm");
  emit("update:modelValue", false);
};
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    :persistent="persistent"
    max-width="90%"
    width="500"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <p class="text-h5 text-center py-6" v-html="text" />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="flat" @click="handleConfirm">확인</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
